module.exports = __webpack_public_path__ + "media/r_artus.35371ee2.mp3";